import { ExtraProduct, ProductConfig } from "ts/api/product";
import { Currency } from "@evennt-tech/api-v2-core";
import formatPrice from "tools/formats/formatPrice";
import {
  getCpoConfigItemsConcatValue,
  separateConfigItemsByType,
} from "view/apps/Supplier/pages/Products/List/components/ProductDetailsDrawer/components/CustomProductOptionConfigModal/CustomProductOptionConfigItemForm/utills/helpers";

export const getExtrasString = (extras: ExtraProduct[], currency: Currency) =>
  extras.reduce((acc, extraProduct, idx, arr) => {
    const isLast = idx === arr.length - 1;
    const amount = (extraProduct.quantity || 1) * extraProduct.priceWithFees;
    const formattedAmount = formatPrice(amount, currency);
    let newValue = `${extraProduct.name} (+${formattedAmount})`;
    if (!isLast) {
      newValue += ", ";
    }

    acc += newValue;
    return acc;
  }, "");

export const getCustomCpoString = (config: ProductConfig): string => {
  const groupedItems = separateConfigItemsByType(config.items);
  const concatValue = getCpoConfigItemsConcatValue(groupedItems, ", ");
  return `${concatValue ? ", " : ""}${concatValue}`;
};
